module.exports = __webpack_public_path__ + "img/hopways.9ef18047.webp";